import React from 'react';
import Dropdown from '../Dropdown';
import Slider from 'common/components/Slider';
import Button from 'common/components/Button';
import useFiltersStore from '_viewport-maps/src/store/useFiltersStore';
import { filterDefaults, sendCloseDropdownEvent } from '_viewport-maps/src/util/filters';
import settings from '_viewport-maps/src/util/config';
import { BUTTON_TYPES } from 'common/types/forms';
const PriceBoundsDropdown = () => {
    const { priceBounds, setPriceBounds, resetPriceBounds, setApplyFilterFlag } = useFiltersStore();
    return (React.createElement(Dropdown, { toggleClass: "filter-dropdown", toggleChildren: React.createElement(React.Fragment, null,
            React.createElement("span", { className: "filter-dropdown__label" }, priceBounds === filterDefaults.priceBounds
                ? settings.FilterPriceRangeLabel
                : `$${priceBounds.selectedMin} - $${priceBounds.selectedMax}`),
            React.createElement("i", { className: "filter-dropdown__symbol fas fa-angle-down" })), contentClass: "filter-dropdown__content" },
        React.createElement(Slider, { className: "viewport-map__price-slider", title: settings.FilterPriceRangeLabel, minValue: settings.FilterMinPriceValue, maxValue: settings.FilterMaxPriceValue, sliderBounds: priceBounds, minInputLabel: settings.FilterMinPriceLabel, maxInputLabel: settings.FilterMaxPriceLabel, onSliderChange: (sliderBounds) => setPriceBounds(sliderBounds), step: 5000, currency: true, maxPricePlus: true }),
        React.createElement("hr", { className: 'filter-horizontal-divider' }),
        React.createElement("div", { className: "flex-between viewport-map__filters__buttons" },
            React.createElement(Button, { type: BUTTON_TYPES.BUTTON_LINK, className: "viewport-map__filters__clear-button", onCLick: (event) => {
                    resetPriceBounds();
                    sendCloseDropdownEvent(event.target);
                } }, settings.FilterClearLabel),
            React.createElement(Button, { type: BUTTON_TYPES.BUTTON_PRIMARY_SMALL, className: "viewport-map__filters__save-button", onCLick: (event) => {
                    setApplyFilterFlag(true);
                    sendCloseDropdownEvent(event.target);
                } }, settings.FilterSaveLabel))));
};
export default PriceBoundsDropdown;
